import { StyleSheet, View } from 'react-native';

const HelpBackground: React.FC = () => {
  return (
    <View style={styles.background}>
      {/* No momento o time de design só forneceu uma imagem provisória no design,
          e por ter alguns filmes e séries que não podemos usar (Vingadores, por exemplo),
          vamos manter sem o background até que a imagem final seja fornecida
          <Image w="$full" h={810} source={HelpBackgroundImage} /> */}
    </View>
  );
};

const styles = StyleSheet.create({
  background: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    overflow: 'hidden',
    opacity: 0.3,
  },
});

export default HelpBackground;
